import React, { useEffect, useState } from 'react';

const ServiceButton = ({ title, isActive, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`transition-all duration-300 flex justify-center items-center py-3 px-6 border border-[#272726] ${
        isActive ? 'bg-[#3A4B24] text-white' : 'bg-[#272726] text-white'
      }`}
    >
      <span
        className="b_a1"
      >
        {title}
      </span>
    </button>
  );
};

export const ServicesSticky = ({ settings }) => {
  const [activeButton, setActiveButton] = useState(null);
  const [isSticky, setIsSticky] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const {
    blocks = [],
    sticky_from_top = true,
    offset_top = 0,
    scroll_to_sections = true,
    active_button_color = '#3A4B24',
    inactive_button_color = '#272726',
    active_text_color = '#FFFFFF',
    inactive_text_color = '#FFFFFF',
    center_buttons = true,
    full_width = false,
    scroll_threshold = 300
  } = settings;

  useEffect(() => {
    if (blocks && blocks.length > 0) {
      setActiveButton(blocks[0].id);
    }

    if (scroll_to_sections) {
      const handleScroll = () => {
        // Check if we should make the navigation sticky and visible
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const shouldBeSticky = sticky_from_top ? scrollTop > offset_top : true;
        const shouldBeVisible = scrollTop > (scroll_threshold || 300);
        
        setIsSticky(shouldBeSticky);
        setIsVisible(shouldBeVisible);

        // Find which section is currently in view
        const sections = blocks.map((button) => {
          if (button.settings && button.settings.target) {
            const element = document.getElementById(button.settings.target);
            if (element) {
              const rect = element.getBoundingClientRect();
              return { id: button.settings.button_title, top: rect.top, bottom: rect.bottom };
            }
          }
          return null;
        }).filter(Boolean);

        // Find the section closest to the top of the viewport
        const currentSection = sections.reduce((closest, section) => {
          if (section && section.top < 100 && section.bottom > 0) {
            return !closest || Math.abs(section.top) < Math.abs(closest.top)
              ? section
              : closest;
          }
          return closest;
        }, null);

        if (currentSection) {
          setActiveButton(currentSection.id);
        }
      };

      window.addEventListener('scroll', handleScroll);
      // Initial check
      handleScroll();

      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [blocks, scroll_to_sections, sticky_from_top, offset_top, scroll_threshold]);

  const handleButtonClick = (buttonId: string, target?: string) => {
    setActiveButton(buttonId);
    if (target && scroll_to_sections) {
      const element = document.getElementById(target);
      if (element) {
        const offset = offset_top + (isSticky ? document.querySelector('.services-sticky')?.clientHeight || 0 : 0);
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <div
      className={`services-sticky w-full ${
        isSticky ? 'fixed bottom-0 left-0 z-20' : ''
      } ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      } transition-all duration-500`}
      style={{ bottom: isSticky ? `${offset_top}px` : '0' }}
    >
      <div className={`${full_width ? 'w-full' : 'container mx-auto'}`}>
        <div
          className={`flex flex-nowrap overflow-x-auto scrollbar-hide ${
            center_buttons ? 'justify-center' : 'justify-start'
          }`}
        >
          {blocks.map((button) => (
            <ServiceButton
              key={button.settings.button_title}
              title={button.settings.button_title}
              isActive={activeButton === button.settings.button_title}
              onClick={() => handleButtonClick(button.settings.button_title, button.settings.target)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesSticky;